import PostApi from "../includes/logic/Api/PostApi";

export default class FeedbackApi {
  static async sendFeedback(fd: FormData) {
    return await PostApi.sendRequest('tg', 'sendFeedback', fd, {
      headers: {
        "Content-Type": 'multipart/form-data'
      }
    })
  }
}
